export default __webpack_public_path__ + "static/media/Moon.98d96713.svg";